module.exports = __webpack_public_path__ + "img/photo-smoothie-studio.9004a21d.png";